// Domain
import { SearchTransactionTypeRepository } from '../../domain/repositories/search-transaction-type-repository';
import { TransactionTypeEntity } from '../../domain/entities/transaction-type-entity';
import TYPES from '@/modules/shared/types';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class SearchTransactionTypesHttpRepository implements
  SearchTransactionTypeRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/allianz/transaction_type/`;

  execute(): Promise<Array<TransactionTypeEntity>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint)
        .then((response) => {
          response.json()
            .then(({ success, data, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
